import { render, staticRenderFns } from "./CreateMyProfile.vue?vue&type=template&id=dd7ba40a"
import script from "./CreateMyProfile.vue?vue&type=script&lang=js"
export * from "./CreateMyProfile.vue?vue&type=script&lang=js"
import style0 from "./CreateMyProfile.vue?vue&type=style&index=0&id=dd7ba40a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports